
// @ts-ignore
import {translate} from '@elements/translations';
import {defineComponent, ref} from "vue";
import {getLocaleDateString} from "../../utils/utils";
import {useTicketStore} from '../../stores/TicketStore';
import {useActivityStore} from '../../stores/ActivityStore';
import {storeToRefs} from 'pinia'

export default defineComponent({
    name: 'Breadcrumb',
    props: {
        stepViews: {
            type: Array,
            required: true,
        },
        step: {
            type: Number,
            required: true,
        },
        changeStep: {
            type: Function,
            required: false,
        },
        type: {
            type: String,
            required: false,
            default: "ticket"
        },
    },
    emits: ['changeStep'],
    setup(props, {emit}) {

        const isActivity = props.type === "activity";
        const ticketStore = isActivity ? useActivityStore() : useTicketStore();
        const isPricecalculator = props.type === 'pricecalculator';

        const {
            selectedDateStart,
            selectedDateEnd,
            selectedOption,
            selectedInsurance,
            selectedUpgrades,
            allOptions,
            allUpgrades,
            allInsurances,
        } = storeToRefs(ticketStore);
        const changeStep = (step) => {
            emit('changeStep', step);
        }

        const priceCalculatorBreadcrumbs = ref([])
        if(isPricecalculator) {
            const data = {
                label: translate('shop.configuration.breadcrumb.Date') + ":",
                value: ''
            }

            if(selectedDateEnd.value !== '' && getLocaleDateString(selectedDateStart.value) !== getLocaleDateString(selectedDateEnd.value)) {
                data.value = getLocaleDateString(selectedDateStart.value) + ' - ' + getLocaleDateString(selectedDateEnd.value)

            } else {
                data.value = getLocaleDateString(selectedDateStart.value)
            }

            priceCalculatorBreadcrumbs.value.push({
                label: data.label,
                value: data.value
            })
        }

        const getBreadcrumbs = (): Object[] => {
            let breadcrumbs = [];

            if(isActivity){
                for (let i = 0; i < props.step; i++) {
                   breadcrumbs.push({
                       label: translate('shop.configuration.breadcrumb.Date') + ":",
                       value: selectedDateEnd.value !== "" ? getLocaleDateString(selectedDateEnd.value) : "",
                       buttonText: translate('shop.configuration.breadcrumb.Edit-date'),
                       step: i
                   })
                }
            } else {
                for (let i = 0; i < props.step; i++) {
                    let view = props.stepViews[i];
                    if (view === 'calendar') {
                        breadcrumbs.push({
                            label: translate('shop.configuration.breadcrumb.Date') + ":",
                            value: selectedDateEnd.value !== "" ? getLocaleDateString(selectedDateStart.value) +  " " + translate('shop.configuration.breadcrumb.to') + " " +  getLocaleDateString(selectedDateEnd.value) : getLocaleDateString(selectedDateStart.value),
                            buttonText: translate('shop.configuration.breadcrumb.Edit-date'),
                            step: i
                        })
                    } else if (view === 'services' && props.stepViews[props.step] !== 'summary') {
                        let services = [];
                        allOptions.value.forEach((option) => {
                            if (option.id === selectedOption.value) {
                                services.push(option.label);
                            }
                        })
                        allInsurances.value.forEach((insurance) => {
                            if (insurance.id === selectedInsurance.value) {
                                services.push(insurance.label);
                            }
                        })
                        allUpgrades.value.forEach((upgrade) => {
                            if (selectedUpgrades.value.includes(upgrade.id)) {
                                services.push(upgrade.label);
                            }
                        })

                        let servicesString = services.map((service) => {
                            // if not last element
                            if (services.indexOf(service) !== services.length - 1) {
                                return service + "<span class='breadcrumb-item__separator'>|</span>";
                            } else {
                                return service;
                            }
                        });

                        breadcrumbs.push({
                            label: "",
                            value: servicesString.join(""),
                            buttonText: translate('shop.configuration.breadcrumb.Edit-configuration'),
                            step: i
                        })
                    }
                }
            }

            return breadcrumbs;
        }

        return {
            getBreadcrumbs,
            changeStep,
            translate,
            priceCalculatorBreadcrumbs
        };
    }
});
